/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_FixedInputs */

const en_task_catalog_type_fixed = /** @type {(inputs: Task_Catalog_Type_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The system sets this field.`)
};

const pt_br2_task_catalog_type_fixed = /** @type {(inputs: Task_Catalog_Type_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O sistema define este campo.`)
};

/**
* | output |
* | --- |
* | "The system sets this field." |
*
* @param {Task_Catalog_Type_FixedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_fixed = /** @type {((inputs?: Task_Catalog_Type_FixedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_FixedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_fixed(inputs)
	return pt_br2_task_catalog_type_fixed(inputs)
});